import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as types from '../constants/actionTypes';
import Cookies from 'js-cookie';

class OAuthLoginPage extends Component {

    constructor(props) {
        super(props);

        // Check for the 'cas_redirect' cookie
        const casRedirect = Cookies.get('cas_redirect');

        if (this.props.location.query.access_token && this.props.location.query.expires && this.props.location.query.username) {
            this.login(this.props.location.query.access_token, this.props.location.query.expires,
            this.props.location.query.username,this.props.location.query.user_id, this.props.location.query['roles[]'],
                this.props.location.query.redir);

            // If 'cas_redirect' cookie exists, perform the redirect and then delete the cookie
            if (casRedirect) {
                window.location.assign(casRedirect);
                Cookies.remove('cas_redirect');
            }
        } else {
            //redirect to api login url
            /* global CAS_LOGIN_URL,API_LOGIN_URL */
            let login_url = `${CAS_LOGIN_URL}?service=${encodeURI(API_LOGIN_URL)}&redirect=${this.props.location.query.redirect}`;

            if (this.props.location.query.redirect) {
                // Set cas_redirect in a 5-minute cookie
                Cookies.set('cas_redirect', this.props.location.query.redirect, { expires: 5 / 1440 });
            }

            window.location.assign(login_url);
        }
    }

    componentWillReceiveProps(newProps) {

        if (newProps.pageState.auth.isAuthenticated) {
            //sets state
            const serializedState = JSON.stringify(newProps.pageState);
            localStorage.setItem('state', serializedState);
            let redirect_url = decodeURIComponent(newProps.pageState.auth.redir).match(/redirect=([^&]*)/);
            if (redirect_url && redirect_url.length > 1 && redirect_url[1].length > 1){
                this.props.router.replace(redirect_url[1]);
            } else {
                this.props.router.replace('/');
            }
        }
    }

    login(access_token, expires, username, user_id, roles, redir = '/') {
        this.props.dispatch({
            type: types.OAUTH__LOGIN,
            payload: {
                id: user_id,
                username: username,
                token: access_token,
                expires: expires,
                roles: roles,
                redir: redir
            }
        });
    }

    render() {
        return null;
    }
}

OAuthLoginPage.propTypes = {
    dispatch: React.PropTypes.func.isRequired,
    pageState: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    location: React.PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        pageState: state
    };
};

export default connect(mapStateToProps)(withRouter(OAuthLoginPage));




/** WEBPACK FOOTER **
 ** ./src/containers/OAuthLoginPage.js
 **/